import { BaseModel } from "../base.model";

export class AuditObjectType extends BaseModel {
  id: number;
  name: string;
}
